var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"architecture"},[_c('div',{staticClass:"show-act-box"},[_vm._m(0),_c('div',{staticClass:"act-list"},_vm._l((_vm.actList2),function(item){return _c('ShowActBox',{key:item,attrs:{"showData":{
          imageUrl:
            'http://c.vpimg1.com/upcb/2023/07/06/13/ias_1688636343067448260.jpg',
        }}})}),1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-title"},[_c('div',{staticClass:"title-left"},[_vm._v("关于建筑")]),_c('div',{staticClass:"title-right"},[_vm._v("查看全部")])])
}]

export { render, staticRenderFns }